[
  {
    "id": "dashboard",
    "link": "home/dashboard",
    "title": "Nav.Links.Dashboard",
    "translateTitle": true,
    "icon": "fa fa-tachometer-alt",
    "layout": "dashboard",
    "forbiddenRoles": ["UserRegistrationPending"]
  },
  {
    "id": "catalogs",
    "title": "Nav.Links.Catalogs",
    "translateTitle": true,
    "icon": "fa fa-book"
  },
  {
    "id": "user",
    "title": "Nav.Links.UserManagement",
    "translateTitle": true,
    "icon": "fa fa-users",
    "anyRoles": ["UserManagement", "InstitutionGroupAdmin"],
    "subItems": [
      {
        "id": "user/management",
        "link": "user/management",
        "title": "Nav.Links.UserManagement",
        "translateTitle": true,
        "icon": "fa fa-users"
      },
      {
        "id": "user/management/pending",
        "link": "user/management/pending",
        "title": "Nav.Links.UserManagementPending",
        "translateTitle": true,
        "icon": "fa fa-user-plus"
      },
      {
        "id": "user/groups",
        "link": "user/groups",
        "title": "Nav.Links.UserGroups",
        "translateTitle": true,
        "icon": "fa fa-users",
        "requiredRoles": ["Admin"]
      }
    ]
  },
  {
    "id": "employee",
    "title": "Nav.Links.Employee",
    "translateTitle": true,
    "icon": "fa fa-users"
  },
  {
    "id": "user/contracts",
    "link": "user/contracts",
    "title": "Nav.Links.UserContracts",
    "translateTitle": true,
    "icon": "fa fa-file-signature"
  },
  {
    "id": "insurance/contracts",
    "link": "insurance/contracts",
    "title": "Nav.Links.InsuranceContracts",
    "translateTitle": true,
    "icon": "fa fa-file-signature",
    "requiredRoles": ["ViewContracts"]
  },
  {
    "id": "insurance/pendingcontracts",
    "link": "insurance/pendingcontracts",
    "title": "Nav.Links.PendingInsuranceContracts",
    "translateTitle": true,
    "icon": "fa fa-file-signature",
    "requiredRoles": ["EditContracts"]
  },
  {
    "id": "home/info",
    "link": "home/info",
    "title": "Nav.Links.Info",
    "translateTitle": true,
    "icon": "fa fa-info",
    "forbiddenRoles": ["UserRegistrationPending"]
  },
  {
    "id": "admin",
    "title": "Nav.Dropdowns.Admin",
    "translateTitle": true,
    "icon": "fa fa-tools",
    "anyRoles": ["Admin", "InstitutionGroupAdmin"],
    "subItems": [
      {
        "id": "admin/info",
        "link": "admin/info",
        "title": "Nav.Links.AdminInfo",
        "translateTitle": true,
        "icon": "fa fa-info",
        "requiredRoles": ["Admin"]
      },
      {
        "id": "admin/eventlogs",
        "link": "admin/eventlogs",
        "title": "Nav.Links.EventLogs",
        "translateTitle": true,
        "icon": "fa fa-file-alt",
        "requiredRoles": ["Admin"]
      },
      {
        "id": "admin/emails",
        "link": "admin/emails",
        "title": "Nav.Links.Emails",
        "translateTitle": true,
        "icon": "fa fa-envelope",
        "requiredRoles": ["Admin"]
      },
      {
        "id": "admin/rules",
        "link": "admin/rules",
        "title": "Nav.Links.Rules",
        "translateTitle": true,
        "icon": "fa fa-diagram-project",
        "requiredRoles": ["Admin"]
      },
      {
        "id": "admin/insurances",
        "link": "admin/insurances",
        "title": "Nav.Links.Insurances",
        "translateTitle": true,
        "icon": "fa fa-building-columns",
        "requiredRoles": ["Admin"]
      },
      {
        "id": "admin/institutions",
        "link": "admin/institutions",
        "title": "Nav.Links.Institutions",
        "translateTitle": true,
        "icon": "fa fa-hospital",
        "requiredRoles": ["Admin"]
      },
      {
        "id": "admin/contracts",
        "link": "admin/contracts",
        "title": "Nav.Links.Contracts",
        "translateTitle": true,
        "icon": "fa fa-file-contract",
        "anyRoles": ["Admin", "InstitutionGroupAdmin"]
      },
      {
        "id": "admin/statistics",
        "link": "admin/statistics",
        "title": "Nav.Links.Statistics",
        "translateTitle": true,
        "icon": "fa fa-chart-line",
        "requiredRoles": ["Admin"]
      }
    ]
  },
  {
    "id": "user/delegation",
    "link": "user/delegation",
    "title": "Nav.Links.Delegation",
    "translateTitle": true,
    "icon": "fa fa-user-doctor",
    "requiredRoles": ["Delegate"]
  },
  {
    "id": "invoice",
    "title": "Nav.Dropdowns.Invoice",
    "translateTitle": true,
    "icon": "fa fa-file-lines",
    "anyRoles": ["InvoiceTermsNotAccepted", "Invoice", "InvoiceControlling"],
    "subItems": [
      {
        "id": "invoiceTermsNotAccepted",
        "action": "acceptInvoiceTerms",
        "title": "Nav.Links.AcceptInvoiceTerms",
        "translateTitle": true,
        "icon": "fa fa-file-signature",
        "requiredRoles": ["InvoiceTermsNotAccepted"]
      },
      {
        "id": "invoice/controlling",
        "link": "invoice/controlling",
        "title": "Nav.Links.InvoiceControlling",
        "translateTitle": true,
        "icon": "fa fa-list-check",
        "requiredRoles": ["InvoiceControlling"]
      },
      {
        "id": "invoice/serviceproviders",
        "link": "invoice/serviceproviders",
        "title": "Nav.Links.InvoiceServiceProviders",
        "translateTitle": true,
        "icon": "fa fa-users",
        "requiredRoles": ["InvoiceControlling"]
      },
      {
        "id": "user/patients",
        "link": "user/patients",
        "title": "Nav.Links.Patients",
        "translateTitle": true,
        "icon": "fa fa-users",
        "requiredRoles": ["Invoice", "CloseContractsUser"]
      },
      {
        "id": "user/invoices",
        "link": "user/invoices",
        "title": "Nav.Links.Invoices",
        "translateTitle": true,
        "icon": "fa fa-file-lines",
        "requiredRoles": ["Invoice"]
      },
      {
        "id": "invoice/delegations",
        "link": "invoice/delegations",
        "title": "Nav.Links.InvoiceDelegations",
        "translateTitle": true,
        "icon": "fa fa-user-check",
        "requiredRoles": ["Invoice"],
        "forbiddenRoles": ["Delegate"]
      },
      {
        "type": "divider",
        "anyRoles": ["Invoice", "InvoiceControlling"]
      },
      {
        "id": "invoice/manual",
        "action": "openInvoiceManual",
        "title": "Nav.Links.InvoiceManual",
        "translateTitle": true,
        "icon": "fa fa-book",
        "anyRoles": ["Invoice", "InvoiceControlling"]
      },
      {
        "id": "invoice/terms",
        "action": "openInvoiceTerms",
        "title": "Nav.Links.InvoiceTerms",
        "translateTitle": true,
        "icon": "fa fa-file-signature",
        "anyRoles": ["Invoice", "InvoiceControlling"]
      }
    ]
  }
]
